import { useCurrentUser } from 'contexts/CurrentUserContext';
import { Helmet } from 'react-helmet-async';
import { Navigate } from 'react-router-dom';

export default function IndexPage() {
  const { state: currentUserState } = useCurrentUser();

  if (!currentUserState.isInitialized) {
    return (
      <div>
        <Helmet>
          <title>Bend Health</title>
        </Helmet>
      </div>
    );
  }

  return <Navigate to="/home" />;
}
